// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import ContactPreference from './ContactPreference';

// Actions
import { setMobilePhoneNumber } from 'store/reducers/appointment/actions';
import {
  setCustomerMobileNumber,
  setWaitState
} from 'store/reducers/selfCheckIn/actions';
import { gtmContactPreferenceNumberChange } from 'store/reducers/gtm/actions';

// Selectors
import { getContactInfo } from 'store/reducers/appointment/selectors';
import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';
import { getPersonInfo } from 'store/reducers/user/personInfo/selectors';
import { getCustomerMobileNumber } from 'store/reducers/selfCheckIn/selectors';

function mapStateToProps(state) {
  return {
    contactInfo: getContactInfo(state),
    dealerCountryCode: getDealerCountryCode(state),
    personInfo: getPersonInfo(state),
    customerMobileNumber: getCustomerMobileNumber(state)
  };
}

const mapDispatchToProps = {
  setMobilePhoneNumber,
  setCustomerMobileNumber,
  setWaitState,
  gtmContactPreferenceNumberChange
};

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ContactPreference);



// WEBPACK FOOTER //
// ./src/components/molecules/ContactPreference/ContactPreferenceContainer.js